var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon svg-icon"},[_c('use',{attrs:{"href":_vm.validate()}})])}
var staticRenderFns = []

export { render, staticRenderFns }